import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import { splitAbbreviatedAddress } from '@repo/utils';
interface AbbreviatedHexProps extends ComponentProps<'span'> {
  value: string;
  segLength?: number;
}

/**
 * The middle must remain an inline box at zero line-height; inline-block, absolutely positioned,
 * or sr-only content breaks find-in-page's text run. The ellipsis must be CSS-generated; `/ ''`
 * keeps it out of the accessible name where supported.
 * Inherited absolute letter-spacing must also be reset; it adds width per hidden character.
 * The middle uses generic `monospace` because WebKit doesn't collapse Inter's character widths
 * at zero font size, and this keyword avoids loading a web font.
 */
export function AbbreviatedHex(t0) {
  const $ = _c(19);
  let props;
  let segLength;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      segLength,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = segLength;
    $[3] = value;
  } else {
    props = $[1];
    segLength = $[2];
    value = $[3];
  }
  let t1;
  if ($[4] !== segLength || $[5] !== value) {
    t1 = splitAbbreviatedAddress(value, segLength);
    $[4] = segLength;
    $[5] = value;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    head,
    middle,
    tail
  } = t1;
  if (!middle) {
    let t2;
    if ($[7] !== head || $[8] !== props) {
      t2 = <span {...props}>{head}</span>;
      $[7] = head;
      $[8] = props;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  let t2;
  if ($[10] !== middle) {
    t2 = <span className="font-[monospace] text-[0px] leading-[0] tracking-normal">{middle}</span>;
    $[10] = middle;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== tail) {
    t3 = <span className="before:content-['...'] supports-[content:'x'_/_'']:before:content-['...'_/_'']">{tail}</span>;
    $[12] = tail;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== head || $[15] !== props || $[16] !== t2 || $[17] !== t3) {
    t4 = <span {...props}>{head}{t2}{t3}</span>;
    $[14] = head;
    $[15] = props;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}